import {microsoftProvider} from '../utils/firebaseConfig'

// Action Types
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_ERROR = 'LOGIN_ERROR'

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS'
export const LOGOUT_ERROR = 'LOGOUT_ERROR'

export const NEW_USER = 'NEW_USER'

// Thunk Action Creators
export const handleLogin = () => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();

    firebase.auth().signInWithPopup(microsoftProvider)
    .then((result) => {
      console.log(result.additionalUserInfo.isNewUser)
      dispatch({type: LOGIN_SUCCESS});
      if (result.additionalUserInfo.isNewUser == true) {
        dispatch({type: NEW_USER});
      }
    })
    .catch((err) => {
      dispatch({type: LOGIN_ERROR});
    })
  }
}

export const handleLogout = () => {
  return (dispatch, getState, {getFirebase}) => {
    const firebase = getFirebase();
    firebase.auth().signOut()
    .then(()=>{
      dispatch({type: LOGOUT_SUCCESS})
    })
    .catch((err) => {
      dispatch({type: LOGOUT_ERROR, err})
    })
  }
}